Vendd.Scripts.load(function () {

    var $wrapper = $('.js-share-button');

    if ($wrapper.length < 1) {
        return;
    }

    var a = document.createElement('script');
    a.async = true;
    a.src = 'https://static.addtoany.com/menu/page.js';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(a, s);

    a.onload = function () {
        a2a_config.callbacks = a2a_config.callbacks || [];
        a2a_config.callbacks.push({
            ready: addToAnyInit
        });
    }

    function addToAnyInit() {
        a2a_config.target = '.share-this';
        a2a_config.onclick = 1;
        a2a_config.num_services = 6;
        a2a_config.prioritize = ['facebook_messenger', 'viber', 'gmail', 'email', 'x', 'whatsapp'];
        a2a_config.custom_services = [
            ['Instagram',
                "https://www.instagram.com/?url=A2A_LINKURL_ENC&title=A2A_LINKNAME_ENC",
                "/Themes/templateThemeTwo/images/addToAny/instagram.svg",
            ]
        ];
        a2a_config.exclude_services = [
            'wykop', 'yummly', 'xing', 'wordpress', 'wechat', 'vk', 'typepad_post', 'twiddla', 'trello', 'threema', 'symbaloo_bookmarks',
            'svejo', 'stocktwits', 'slashdot', 'refind', 'sitejot', 'rediff', 'qzone', 'pusha', 'printfriendly', 'plurk',
            'pinboard', 'papaly', 'odnoklassniki', 'myspace', 'mixi', 'meneame', 'mendeley', 'mewe', 'mail_ru', 'livejournal',
            'line', 'known', 'kindle_it', 'kakao', 'instapaper', 'houzz', 'hatena', 'hacker_news', 'google_classroom', 'folkd',
            'fark', 'douban', 'draugiem', 'diigo', 'diary_ru', 'citeulike', 'box_net', 'bookmarks_fr', 'blogmarks', 'blogger',
            'bitty_browser', 'bibsonomy', 'balatarin', 'pocket', 'tumblr', 'amazon_wish_list', 'aol_mail', 'telegram',
            'diaspora', 'buffer', 'flipboard', 'digg', 'evernote', 'mastodon', 'sina_weibo'
        ];
        a2a.init('page');
    }

});
